import { ProjectActions } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { put, select } from 'redux-saga/effects'

export function* deleteBlock() {
  const { canvas }: AppState = yield select()

  const { ids } = canvas.block

  if (!ids.length) {
    return
  }

  yield put(commitProjectRequest(ProjectActions.blocks.delete({ ids })))

  yield put({
    type: CanvasActionTypes.CLEAR_SELECTED_BLOCKS,
  })
}
